export const SPEECH_LANG = 'th-TH'

export const isSpeechRecognitionSupported = () =>
  !!(window.SpeechRecognition || window.webkitSpeechRecognition)

export const createSpeechRecognition = () => {
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
  if (!SpeechRecognition) return null
  const recognition = new SpeechRecognition()
  recognition.lang = SPEECH_LANG
  recognition.continuous = true
  recognition.interimResults = true
  return recognition
}

export const mergeFloat32Chunks = (chunks) => {
  const totalLength = chunks.reduce((sum, chunk) => sum + chunk.length, 0)
  const merged = new Float32Array(totalLength)
  let offset = 0
  for (const chunk of chunks) {
    merged.set(chunk, offset)
    offset += chunk.length
  }
  return merged
}

export const encodeWavBlob = (samples, sampleRate) => {
  const buffer = new ArrayBuffer(44 + samples.length * 2)
  const view = new DataView(buffer)
  const writeString = (offset, value) => {
    for (let i = 0; i < value.length; i += 1) {
      view.setUint8(offset + i, value.charCodeAt(i))
    }
  }
  writeString(0, 'RIFF')
  view.setUint32(4, 36 + samples.length * 2, true)
  writeString(8, 'WAVE')
  writeString(12, 'fmt ')
  view.setUint32(16, 16, true)
  view.setUint16(20, 1, true)
  view.setUint16(22, 1, true)
  view.setUint32(24, sampleRate, true)
  view.setUint32(28, sampleRate * 2, true)
  view.setUint16(32, 2, true)
  view.setUint16(34, 16, true)
  writeString(36, 'data')
  view.setUint32(40, samples.length * 2, true)
  let offset = 44
  for (let i = 0; i < samples.length; i += 1) {
    const clamped = Math.max(-1, Math.min(1, samples[i]))
    view.setInt16(offset, clamped < 0 ? clamped * 0x8000 : clamped * 0x7fff, true)
    offset += 2
  }
  return new Blob([view], { type: 'audio/wav' })
}

const PCM_CAPTURE_PROCESSOR_NAME = 'pcm-capture-processor'

const PCM_CAPTURE_WORKLET_SOURCE = `
class PcmCaptureProcessor extends AudioWorkletProcessor {
  process(inputs) {
    const channel = inputs[0] && inputs[0][0]
    if (channel && channel.length) {
      this.port.postMessage(new Float32Array(channel))
    }
    return true
  }
}
registerProcessor('${PCM_CAPTURE_PROCESSOR_NAME}', PcmCaptureProcessor)
`

export const isAudioWorkletSupported = (audioContext) =>
  typeof AudioWorkletNode !== 'undefined' && !!(audioContext && audioContext.audioWorklet)

export const createPcmCaptureNode = async (audioContext, onChunk) => {
  const moduleUrl = URL.createObjectURL(
    new Blob([PCM_CAPTURE_WORKLET_SOURCE], { type: 'application/javascript' }),
  )
  try {
    await audioContext.audioWorklet.addModule(moduleUrl)
  } finally {
    URL.revokeObjectURL(moduleUrl)
  }
  const node = new AudioWorkletNode(audioContext, PCM_CAPTURE_PROCESSOR_NAME, {
    numberOfInputs: 1,
    numberOfOutputs: 1,
    channelCount: 1,
    channelCountMode: 'explicit',
  })
  node.port.onmessage = (event) => onChunk(event.data)
  return node
}
